<div class="badge" [ngClass]="color">
  <span class="caption">
    {{ remainingTimeLabel | translate: { months: remainingTime.months, days: remainingTime.days, hour: remainingTime.hours } }}
  </span>
</div>
